module.exports = __webpack_public_path__ + "static/media/background.a9649b3f.png";